import { useEffect, useState } from 'react';
import { getNobilityReset } from '../services/SettingsService';
import { Countdown } from './Countdown';
import { SidebarWidget } from './SidebarWidget/SidebarWidget';

export function NobilityReset() {
    const [settings, setSettings] = useState(null);

    useEffect(() => {
        let cancelled = false;
        async function load() {
            try {
                const result = await getNobilityReset();
                if (!cancelled) setSettings(result);
            } catch {
                // fail silently — sidebar widget
            }
        }
        load();
        return () => { cancelled = true; };
    }, []);

    const resetDateStr = settings?.find(x => x.key === 'nobilityResetDate')?.value;
    const message      = settings?.find(x => x.key === 'nobilityResetMessage')?.value;

    const countdownDate = resetDateStr
        ? new Date(
            parseInt(resetDateStr.split('-')[0]),
            parseInt(resetDateStr.split('-')[1]) - 1,
            1, 0, 0, 0, 0
          )
        : null;

    return (
        <SidebarWidget title="Nobility Reset">
            <div className="sw-nobility">
                {message && <p className="sw-nobility-msg">{message}</p>}
                <span className="sw-nobility-label">Next Reset</span>
                {countdownDate
                    ? <Countdown className="sw-nobility-countdown" date={countdownDate} />
                    : <p className="sw-nobility-countdown">—</p>
                }
            </div>
        </SidebarWidget>
    );
}
